import { render, staticRenderFns } from "./ButtonFollowModel.vue?vue&type=template&id=01057c05&scoped=true&"
import script from "./ButtonFollowModel.vue?vue&type=script&lang=js&"
export * from "./ButtonFollowModel.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFollowModel.vue?vue&type=style&index=0&id=01057c05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01057c05",
  null
  
)

export default component.exports